import React, {Fragment} from 'react';
import {useMedia} from 'react-use';
// import {Image} from 'native-base';
import {Box, Flex, config as cssConfig} from '@100mslive/react-ui';
import {FirstPersonDisplay} from './FirstPersonDisplay';
// import {ChatView} from './chatView';
import VideoList from './VideoList';
// import {mobileChatStyle} from '../common/utils';
import {useIsChatOpen} from '../AppData/useChatState';

const MAX_TILES_FOR_MOBILE = 4;

/**
 * the below variables are for showing webinar etc. related image if required on certain meeting urls
 */
const webinarProps = JSON.parse(process.env.REACT_APP_WEBINAR_PROPS || '{}');
const eventRoomIDs = webinarProps?.ROOM_IDS || [];
//const eventsImg = webinarProps?.image_file || ''; // the image to show in center
// the link to navigate to when user clicks on the image
const webinarInfoLink = webinarProps?.LINK_HREF || 'https://100ms.live/';

// The center of the screen shows bigger tiles
export const GridCenterView = ({
  peers,
  maxTileCount,
  // hideSidePane,
  showStatsOnTiles,
}: any) => {
  const mediaQueryLg = cssConfig.media.md;
  const limitMaxTiles = useMedia(mediaQueryLg);
  const isChatOpen = useIsChatOpen();
  console.log(isChatOpen, peers);
  return (
    <Fragment>
      <Box
        css={{
          flex: '1 1 0',
          height: '100%',
          '@md': {flex: '2 1 0'},
          width: '80%',
        }}
      >
        {peers && peers.length > 0 ? (
          <VideoList
            showStatsOnTiles={showStatsOnTiles}
            peers={peers}
            maxTileCount={limitMaxTiles ? MAX_TILES_FOR_MOBILE : maxTileCount}
            mode={'center'}
          />
        ) : eventRoomIDs.some((id: any) =>
            window.location.href.includes(id)
          ) ? (
          <Box
            css={{
              display: 'grid',
              placeItems: 'center',
              size: '100%',
              p: '$12',
            }}
          >
                <a href={webinarInfoLink} target="_blank" rel="noreferrer">
                  {/* <Image
                css={{p: '$4', boxShadow: '$sm'}}
                alt="Event template"
                src={eventsImg}
              /> */}
                  info
                  {/* <img
                    src='https://foldhealth-develop-cms-uploads.s3.us-east-2.amazonaws.com/02a088ac-9a36-4886-b3d8-41ba2c74ba5b/fold_logo_89bba4d19d.png'
                    alt='Image'
                    height='150px'
                    width='150px'
                    style={{
                      margin: 10, position: 'absolute', justifyContent: 'flex-start', alignContent: 'flex-start',
                      alignItems: 'flex-start', justifySelf: 'flex-start', marginLeft: 0,
                    }}
                  /> */}
                </a>
          </Box>
        ) : (
          <FirstPersonDisplay />
        )}
      </Box>
      {/* {isChatOpen && hideSidePane && (
        <Flex
          css={{
            height: '75%',
            flex: '0 0 20%',
            zIndex: 40,
            mr: '$4',
            alignSelf: 'flex-end',
            '@md': mobileChatStyle,
            '@ls': {
              minHeight: '100%', // no sidepeer tiles will be present
              bottom: '$7',
            },
          }}
        >
          <ChatView />
        </Flex>
      )} */}
    </Fragment>
  );
};

// Side pane shows smaller tiles
export const GridSidePaneView = ({
  peers,
  showStatsOnTiles,
  maxTileCount,
}: any) => {
  // const isChatOpen = useIsChatOpen();
  const mediaQueryLg = cssConfig.media.md;
  const limitMaxTiles = useMedia(mediaQueryLg);
  return (
    <Flex
      direction="column"
      css={{
        flex: '0 0 20%',
        mx: '$4',
        '@lg': {
          flex: '0 0 25%',
        },
        '@md': {
          flex: '1 1 0',
        },
        width: '20%',
      }}
    >
      <Flex css={{flex: '1 1 0'}} align="start">
        {peers && peers.length > 0 && (
          <VideoList
            showStatsOnTiles={showStatsOnTiles}
            peers={peers}
            maxColCount={10}
            maxTileCount={limitMaxTiles ? MAX_TILES_FOR_MOBILE : maxTileCount}
            mode={'side'}
          />
        )}
      </Flex>
      {/* {isChatOpen && (
        <Flex
          align="end"
          css={{
            flex: '1 1 0',
            h: '50%',
            p: '$4',
            '@md': mobileChatStyle,
            '@ls': {
              ...mobileChatStyle,
              minHeight: '85%',
            },
          }}
        >
          <ChatView />
        </Flex>
      )} */}
    </Flex>
  );
};
